export default __webpack_public_path__ + "static/media/default-project-picture.bde7e1cb.png";